// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"bb578ccf","280":"bb578ccf","345":"72e6d101","867":"a445c569"}[chunkId] + ".chunk.css";
};